<template>
  <div>
     <h1 class="page-title display-1">Tipos de instalación</h1>
  <visible-for v-show="display" superadmin administrator supervisor>
    <vuetify-crud-datatable
      slot="content"
      :name="name"
      :plural-name="pluralName"
      :rows-per-page-items='rowsPerPage'
      :translations="translations"
      :headers="item.headers || []"
      :rows="item.items || []"
      :actions="false"
      :item-key="item.item_value"
      :pagination="item.pagination"
      :defaultColumns="item.default_columns || {}"
      :primary-color="color.primary"
      :checkbox-color="color.checkbox"
      :add-dialog="false"
      :edit-dialog="false"
      @on-click-add-button="onClickAddButton"
      @on-click-edit-button="onClickEditButton"
      :primary-button-color="color.button.primary"
      :secundary-button-color="color.button.secundary"
      @on-delete="onDeleteItem"
      @on-change-columns="onChangeColumns"
      :selected-columns="selectedColumns"
    ></vuetify-crud-datatable>
  </visible-for>
  <pre>

  </pre>
</div>
</template>

<script>
  import Rule from 'mixins/rule'
  import VisibleFor from '@/components/vue-user/visible-for'
  import VuetifyCrudDatatable from '@/components/vuetify-crud-datatable'

  export default {
    mixins: [Rule],

    components:
    {
      VisibleFor,
      VuetifyCrudDatatable
    },

    data () {
      return {
        taxonomyType: this.$route.params.type || '',
        name: '',
        pluralName: '',
        item: {},
        customColumnsResponse: null,
        selectedColumns: [],
        display: false,
        translations: {
          new: 'Nueva',
          delete_selecteds: 'Eliminar seleccionados',
          delete_element_message: 'Estás a punto de eliminar la',
          edit: 'Editar',
          cancel: 'Cancelar',
          delete: 'Eliminar',
          save: 'Guardar',
          delete_element: '¡ATENCIÓN!',
          search: 'Buscar',
          columns: 'Columnas',
          columns_info: 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro',
          columns_warning: 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto',
          restart_columns: 'Reiniciar columnas',
          reset: 'Reiniciar',
          rows_per_page_items: 'Filas por página',
          no_results_text: 'No hay datos disponibles',
          no_data_text: 'No hay coincidencias',
          from: 'Desde',
          to: 'hasta',
          no_results_found_for: 'No se encontraron resultados para'
        },
        color: {
          checkbox: 'primary',
          primary: 'primary',
          success: 'success',
          error: 'error',
          button: {
            primary: 'primary',
            secundary: 'secundary'
          }
        },
        rowsPerPage: [5, 10, 25, { 'text': 'Todas', 'value': -1 }]
      }
    },

    created () {
      this.getCustomColumns().then((response) => {
        this.getItems().then((response) => {
          // console.log(response)
          this.item = this.normalizeTypes(response.data)
          this.display = true
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeTypes (item) {
        this.name = 'tipo de instalación'
        this.pluralName = 'tipos de instalación'
        item.pagination = this.setPagination(item)
        item.default_columns = this.setDefaultColumns(item)
        item.headers = this.setHeaders(item)
        this.setTranslations()
        return item
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setPagination (item) {
        return {
          sortBy: item.item_value,
          descending: true,
          rowsPerPage: -1
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setDefaultColumns (item) {
        return {
          value: false,
          [item.item_value]: 0,
          [item.item_text]: '',
          [item.item_text_2]: '',
          [item.item_text_3]: '',
          [item.item_text_4]: '',
          [item.item_text_5]: '',
          [item.item_text_6]: '',
          [item.item_text_7]: '',
          [item.item_text_8]: '',
          [item.item_text_9]: '',
          [item.item_text_10]: '',
          [item.item_text_11]: '',
          [item.item_text_12]: ''
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setHeaders (item) {
        // console.log(item)
        return [
          {
            text: 'ID',
            value: item.item_value,
            align: 'left',
            type: 'span',
            editable: false,
            sortable: true
          },
          {
            text: 'Tipo de instalación',
            align: 'left',
            sortable: true,
            value: item.item_text,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 1 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_2,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 2 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_3,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Tarifa 3 (€ sin IVA)',
            align: 'left',
            sortable: true,
            value: item.item_text_4,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Duración (horas)',
            align: 'left',
            sortable: true,
            value: item.item_text_5,
            type: 'editable-text-field',
            editable: true,
            main: true,
            rules: (v) => v.length <= 255 || '¡Texto demasiado largo!',
            counter: 255
          },
          {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            type: 'actions',
            sortable: false,
            editable: true,
            fixed: true
          }
        ]
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'user/option/' + userID + '/equipments_columns/'
          }).then((response) => {
            this.customColumnsResponse = response.data
            this.selectedColumns = JSON.parse(this.customColumnsResponse.user_option_value)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateCustomColumns () {
        return new Promise((resolve, reject) => {
          let userID = parseInt(this.$store.getters['api/getUserId'])
          this.$store.dispatch('api/authRequest', {
            method: 'put',
            url: 'user/option/' + userID + '/equipments_columns/',
            data: {
              option_id: this.customColumnsResponse.user_option_id,
              option_value: JSON.stringify(this.selectedColumns)
            }
          }).then((response) => {
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al actualizar la disposición de las columnas: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChangeColumns (customColumns) {
        this.selectedColumns = customColumns
        this.updateCustomColumns()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      setTranslations () {
        this.translations.new = 'Nuevo'
        this.translations.delete_selecteds = 'Eliminar seleccionados'
        this.translations.delete_element_message = 'Estás a punto de eliminar el'
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getItems () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('api/authRequest', {
            method: 'get',
            url: 'installation/types/'
          }).then((response) => {
            // console.log(response.data)
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.$store.dispatch(
              'snackbar/show',
              'Error al obtener el perfil: ' + this.$store.getters['api/getMessage']
            )
            reject(error.response)
          })
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDeleteItem (index) {
        let id = this.item.items[index][this.item.item_value]
        this.$store.dispatch('api/authRequest', {
          method: 'delete',
          url: 'installation/type/' + id + '/'
        }).then((response) => {
          console.log(response.data)
          this.$store.dispatch(
            'snackbar/show',
            '¡Hecho!'
          )
        }).catch((error) => {
          console.log(error)
          this.$awn.alert('Este equipo está asignado a alguna reserva y no puedes eliminarlo.')
        })
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickAddButton () {
        this.$router.push(
          {
            name: 'installation-type-id',
            params: {
              installation_type_id: 'new'
            }
          }
        )
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickEditButton (index, id) {
        this.$router.push(
          {
            name: 'installation-type-id',
            params: {
              installation_type_id: id
            }
          }
        )
      }
    }
  }
</script>

<style lang="sass">

.application
  background: rgba(63, 81, 181, 0.07058823529411765) !important

</style>



// WEBPACK FOOTER //
// src/pages/installation-types.vue